// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"081367b2","160":"c38523bd","208":"c9e6de46","293":"1ad80e7f","453":"d8028bec","516":"39a4652c","519":"e5e1e022","917":"bf680a68","946":"207c7f9f"}[chunkId] + ".chunk.js";
};